export default "__VITE_ASSET__BkqsFZuZ__"